import tokens from '@kluein/design-tokens';
import { Box } from '@kluein/klue-ui';
import { NectarIcon } from '@kluein/nectar';

import type { IconProps } from '@phosphor-icons/react';

const purple = tokens.color.primitives.violet[450];

type KlueAILogoProps = {
  klueIconSize?: IconProps['size'];
  aiIconSize?: IconProps['size'];
};

export function KlueAILogo({
  klueIconSize = tokens.iconSize.xlarge,
  aiIconSize = tokens.iconSize.medium,
}: KlueAILogoProps) {
  return (
    <Box direction="row" align="center" gap="xxsmall">
      <NectarIcon.KlueLogo size={klueIconSize} color={purple} />
      <NectarIcon.KlueAI size={aiIconSize} color={purple} weight="regular" />
    </Box>
  );
}
